import { Redirect } from "react-router-dom";
import { TermsAgreement } from "../../components/terms-agreement";
import { FriendsAndFamilyContent } from "../../components/terms-agreement/content";
import { useFlowPath } from "../../hooks/use-flow-path";
import { useTermsAgreementState } from "../../store/use-terms-agreement-state";
import { configName } from "../config/config-name";
import { routes } from "../config/routes";
import { useRoutes } from "../hooks/use-routes";

export const TermsAgreementPage = () => {
  const flowPath = useFlowPath();
  const { goToCatalog } = useRoutes();
  const acceptTerms = useTermsAgreementState((s) => s.acceptTerms);
  const accepted = useTermsAgreementState((s) => Boolean(s.acceptedConfigs[configName]));

  if (accepted) {
    return <Redirect to={flowPath(routes.catalog.raw())} />;
  }

  return (
    <TermsAgreement
      content={<FriendsAndFamilyContent />}
      onAccept={() => {
        acceptTerms(configName);
        goToCatalog();
      }}
    />
  );
};
